import { FileExclamationOutlined } from '@ant-design/icons';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import type Asset from 'stores/Asset';
import store from 'stores/RootStore';
import { AnimationPanelViews } from 'types/AnimationPanelViews';
import { offerDownload } from 'utils/Download';
import { removeFilenameExtension } from 'utils/String';

import Drawer from '../Drawer';
import ExportOption from './ExportOption';

const NoExportsPlaceholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ddd;
  height: 100%;
  width: 100%;
  flex-flow: column;
`;

function determineFilenameStem(animAsset: Asset | undefined) {
  return (
    removeFilenameExtension(animAsset?.data.name || '') ||
    removeFilenameExtension(animAsset?.filename || '') ||
    'animation'
  );
}

function ExportDrawer() {
  const store_animation = store.animation;
  const currentAnimationAsset = store_animation?.currentAnimationAsset;
  const store_animation_exporter = store_animation?.exporter;
  const filenameStem = determineFilenameStem(currentAnimationAsset);

  return (
    <Drawer label="Export" panelName={AnimationPanelViews.EXPORT}>
      {currentAnimationAsset ? (
        <>
          {/* ??? hardcoded 100KB */}
          <ExportOption
            name="Lottie JSON"
            fileSize="100KB"
            onDownload={() => {
              if (currentAnimationAsset.downloadURL) {
                void offerDownload(
                  currentAnimationAsset.downloadURL,
                  `${filenameStem}.json`
                );
              }
            }}
          />
          {/*
            Guard is defensive, for TS satisfaction - normally if
            currentAnimationAsset is present, store_animation_exporter should
            be as well because we only get currentAnimationAsset if
            store_animation is present, and RootStore.exporter is not
            optional/nullable
          */}
          {store_animation_exporter && (
            <ExportOption
              name="dotLottie"
              fileSize={store_animation_exporter.fileSize}
              onDownload={() => {
                void store_animation_exporter.download(
                  `${filenameStem}.lottie`
                );
              }}
            />
          )}
        </>
      ) : (
        <NoExportsPlaceholder>
          <FileExclamationOutlined style={{ fontSize: '40px' }} />
          <p style={{ color: '#ccc' }}>No animation to export</p>
        </NoExportsPlaceholder>
      )}
    </Drawer>
  );
}

export default observer(ExportDrawer);
